import React, { useState } from "react";
import { ScrollText, Check, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export const SendToPrompterButton = ({ title, text, source = "manual", testid }) => {
  const [state, setState] = useState("idle");
  const send = async () => {
    if (!text?.trim()) { toast.error("Nothing to send yet"); return; }
    setState("busy");
    try {
      const { data } = await api.post("/prompter/send", {
        title: title || "Untitled segment", script_text: text, source_module: source,
      });
      setState("done");
      toast.success(`Added to "${data.rundown_title}"`, {
        action: { label: "Open Prompter", onClick: () => { window.location.href = "/dashboard/prompter"; } },
      });
      setTimeout(() => setState("idle"), 2500);
    } catch (e) {
      setState("idle");
      toast.error(e?.response?.data?.detail || "Could not send to The Prompter");
    }
  };
  return (
    <button
      onClick={send}
      disabled={state === "busy"}
      data-testid={testid}
      title="Send this script to The Prompter rundown"
      className="inline-flex items-center gap-1 rounded-md border border-cyan-500/50 bg-cyan-500/10 px-2 py-1 text-xs text-cyan-300 hover:bg-cyan-500/20 transition disabled:opacity-50"
    >
      {state === "busy" ? <Loader2 className="h-3 w-3 animate-spin" /> : state === "done" ? <Check className="h-3 w-3" /> : <ScrollText className="h-3 w-3" />}
      {state === "done" ? "Sent" : "To Prompter"}
    </button>
  );
};
